<template>
  <div class="detail-dialog">
    <div class="detail-dialog-header">
      <div class="detail-dialog-header-title">
        {{ title }}
      </div>
      <div class="detail-dialog-header-button">
        <v-btn
          small
          outlined
          color="primary"
          @click.stop="$emit('save', editContext)"
        >
          <v-icon
            small
          >
            mdi-content-save-outline
          </v-icon>
          저장
        </v-btn>
        <div class="custom-spacer" />
        <v-btn
          small
          outlined
          color="red"
          :disabled="!editContext || !editContext.planId"
          @click.stop="$emit('delete', editContext)"
        >
          <v-icon
            small
          >
            mdi-delete-outline
          </v-icon>
          삭제
        </v-btn>
        <div class="custom-spacer" />
        <v-btn
          small
          outlined
          color="primary"
          @click.stop="$emit('close')"
        >
          <v-icon
            small
          >
            mdi-close-box-outline
          </v-icon>
          닫기
        </v-btn>
      </div>
    </div>
    <div class="custom-spacer" />
    <div class="detail-dialog-body">
      <div class="sub-container">
        <div class="sub-title">
          기본정보
        </div>
        <div class="sub-content-wrap">
          <div class="sub-content-item one-third">
            요금제 명:
            <input
              v-model="editContext.planName"
              type="text"
            >
          </div>
          <div class="sub-content-item one-third">
            기본요금 :
            <input
              v-model="editContext.baseFee"
              type="number"
              max="99999999"
              min="0"
            > 원
          </div>
          <div class="sub-content-item one-third">
            사용 여부:
            <select v-model="editContext.useYn">
              <option value="Y">
                사용
              </option>
              <option value="N">
                미사용
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="custom-spacer" />
      <div class="sub-container">
        <div class="sub-title">
          추가료 정보
        </div>
        <div class="sub-content-wrap">
          <table>
            <thead>
            <tr>
              <th>
                추가료 구분
              </th>
              <th>
                기본제공
              </th>
              <th>
                추가기준
              </th>
              <th>
                추가료
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in convertSubPlan" :key="'sublan-'+item.codeKey">
              <td>{{ item.codeValue }}</td>
              <td>
                <input
                  v-model="item.planItem.standardCnt"
                  type="number"
                  max="99999999"
                  min="0"
                > 개
              </td>
              <td>
                <input
                  v-model="item.planItem.addCnt"
                  type="number"
                  max="99999999"
                  min="0"
                > 개 당
              </td>
              <td>
                <input
                  v-model="item.planItem.addFee"
                  type="number"
                  max="99999999"
                  min="0"
                > 원
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="custom-spacer" />
      <div class="sub-container">
        <div class="sub-title">
          비고
        </div>
        <div class="sub-content-wrap">
          <textarea
            v-model="editContext.remark"
          />
        </div>
      </div>
    </div>
    <div class="custom-spacer" />
    <div class="detail-dialog-footer" />
  </div>
</template>

<script>
import time from "../../assets/plugins/mps-common/time";
import {cloneDeep} from "lodash";

export default {
  name: "BasePlanDetail",
  props: {
    item: {
      type: Object,
      default: undefined
    },

    subItemCodes: {
      type: Array,
      default: () => [],
    },

    title: {
      type: String,
      default: '상세',
    },
  },
  data() {
    return {
      editContext: undefined
    }
  },
  computed: {
    convertSubPlan() {
      if (!this.editContext || this.subItemCodes.length <= 0)
        return undefined
      const result = this.subItemCodes.map(e => {
        let planItem = this.editContext.planItems.find(t => t.codeKey === e.codeKey)
        return {
          ...e,
          planItem
        }
      })

      return result
    },
  },
  watch: {
    item: {
      immediate: true,
      deep: true,
      handler(newVal) {
        const cloneItem = cloneDeep(newVal)
        this.subItemCodes.forEach(e => {
          let planItem = cloneItem.planItems?.find(t => t.codeKey === e.codeKey)

          if (!planItem) {
            cloneItem.planItems.push(
              {
                planId: cloneItem.planId || undefined,
                itemName: e.codeValue,
                codeKey: e.codeKey,
                standardCnt: 0,
                addCnt: 0,
                addFee: 0.00,
                remark: '',
                useYn: 'Y',
                deleteYn: 'N',
              }
            )
          }
        })
        this.editContext = cloneItem
      }
    }
  },
}
</script>

<style scoped>
.detail-dialog {
  background: #fff;
  padding: 12px;
  width: 100%;
  min-width: 1000px;
  max-width: 1000px;
}

.detail-dialog > div {
  padding: 4px 0;
}

.detail-dialog-header {
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #dddddd;
}

.detail-dialog-header-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}

.detail-dialog-header-button {
  display: flex;
}

.detail-dialog-body {

}

.sub-container {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.sub-title {
  font-size: 16px;
  text-align: left;
  font-weight: bold;
  color: #333333;
}

.sub-content-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 32px;
}

.sub-content-item {
  display: flex;
  padding-right: 32px;
}

.sub-content-item.one-third {
  width: calc(100% / 3);
}

input,
select {
  flex: 1;
  margin-left: 16px;
  border-bottom: 1px solid #0c98fe;
  color: #1867c0;
  outline: none;
}
textarea {
  width: 100%;
  height: 100px;
  border: 1px solid #d0d0d0;
  resize: none;
}

spacer {
  width: 0;
  height: 0;
  margin: 4px;
}

table {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  border-left: 1px solid #d0d0d0;
  border-top: 1px solid #d0d0d0;
}

table thead tr th {
  background: #0c98fe;
  padding: 2px;
  color: white;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}
table tbody tr:nth-child(2n){
  background: #f4f4f4;
}
table tbody tr td {
  padding: 8px 4px;
  border-right: 1px solid #d0d0d0;
  border-bottom: 1px solid #d0d0d0;
}

table tbody tr td:nth-child(1) {
  text-align: right;
}
</style>